module.exports = __webpack_public_path__ + "media/assets/avia/ticket/plane_white-79fec6a846152b274962550e6f98665c.png";